import { render, staticRenderFns } from "./ExtraFieldsEditor.vue?vue&type=template&id=145143d8&"
import script from "./ExtraFieldsEditor.vue?vue&type=script&lang=js&"
export * from "./ExtraFieldsEditor.vue?vue&type=script&lang=js&"
import style0 from "./ExtraFieldsEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports